import React, { useEffect, useState } from "react";
import DTOJobInfoUpdateModal from "./DTOJobInfoUpdateModal";
import JobInfoUpdateModalPresenter from "./JobInfoUpdateModalPresenter";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import moment from "moment";
import { payloadJobInfoType } from "../../../interfaces/myProfile/personalDetails/jobInfo";
import { jobInfoType } from "../../../interfaces/myProfile/personalDetails/jobInfo";
import { jobInfoReducer } from "../../../../infra/aggregates/myProfile/jobInfoSlice";
import toast from "react-hot-toast";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const JobInfoUpdateModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.jobInfoSlice);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);
  const dispatch = useAppDispatch();
  const [allDepartments, setAllDepartments] = useState<[]>([]);
  const [allEmployeeTypes, setAllEmployeeTypes] = useState<[]>([]);
  const [allContractTypes, setAllContractTypes] = useState<[]>([]);
  const [allEmployeeCategory, setallEmployeeCategory] = useState<[]>([]);
  const [allPayrollTypes, setallPayrollTypes] = useState<[]>([]);

  const getData = (jobInfo_data: payloadJobInfoType) => {
    updatePersonalInfo(jobInfo_data);
  };

  async function callBackDepartments(data: []) {
    setAllDepartments(data);
  }

  async function callBackEmployeeTypes(data: []) {
    setAllEmployeeTypes(data);
  }
  async function callBackContractTypes(data: []) {
    setAllContractTypes(data);
  }
  async function callBackEmployeeCategory(data: []) {
    setallEmployeeCategory(data);
  }
  async function callBackPayrollTypes(data: []) {
    setallPayrollTypes(data);
  }
  async function updatePersonalInfo(data: payloadJobInfoType) {
    if (empId) {
      const payload = {
        emp_id: empId,
        staff_id: data.staff_Id,
        hire_date: data?.hire_date,
        dept_id: data.department_Id,
        emp_type: data.employeeType_Id,
        emp_category: data.employeeCategory_Id,
        payroll_type: data.payrollType_Id,
        contract_type: data.contractType_Id,
        ext_number: data.ext_number,
        locale: localStorage.getItem("emplang"),
      };
      await updatePersonalDetailsService
        .updateJobInfo(payload)
        .then((response: any) => {
          if (response) {
            const job_Info_data: jobInfoType = {
              staffId: response?.staff_id,
              hireDate: response?.data?.hire_date,
              departmentName: response?.data?.department?.name,
              departmentId: response?.data?.department?.id,
              employeeType: response?.data?.employee_type?.name,
              contractType: response?.data?.contract_type?.name,
              employeeCategory: response?.data?.employee_category?.name,
              payrollType: response?.data?.payroll_type?.name,
              employeeCategoryId: response?.data?.employee_category?.id,
              payrollTypeId: response?.data?.payroll_type?.id,
              contractTypeId: response?.data?.contract_type?.id,
              employeeTypeId: response?.data?.employee_type?.id,
              extNo: response?.ext_number,
            };
            dispatch(jobInfoReducer(job_Info_data));

            toast.success(trans("Updated Successfully"));
            closeModal();
          }
        })
        .catch((err) => {
          const _errors = Object.keys(err?.response?.data?.errors);
          toast.error(`${_errors.toString().toUpperCase()} Required!`);
        });
    } else {
      toast.error(trans("Invalid data"));
    }
  }
  return (
    <div>
      <DTOJobInfoUpdateModal
        setAllDepartments={callBackDepartments}
        setAllEmployeeTypes={callBackEmployeeTypes}
        setAllContractTypes={callBackContractTypes}
        setAllEmployeeCategory={callBackEmployeeCategory}
        setAllPayrollTypes={callBackPayrollTypes}
      />
      <JobInfoUpdateModalPresenter
        callBackHandleClockIn={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allDepartments={allDepartments}
        allEmployeeCategory={allEmployeeCategory}
        allEmployeeTypes={allEmployeeTypes}
        allContractTypes={allContractTypes}
        allPayrollTypes={allPayrollTypes}
        selectedEmployeeDetail={selector}
        trans={trans}
      />
    </div>
  );
};

export default JobInfoUpdateModalController;
